module.exports = __webpack_public_path__ + "img/logo_datacore.7263683b.svg";